<template>
  <div
    class="custom-message-component-text"
    :style="style"
    @click="clickHandle"
  >
    {{ content }}
    <slot />
  </div>
</template>

<script lang="ts" >
import { CustomMessageTextComponent } from '_c/typings/model/chat/text-node';
import { pushUrl } from '@/business/chat/custom-message-util';
import { CSSProperties, defineComponent, PropType, toRaw } from 'vue';


export default defineComponent({
  name: 'CustomMessageText',
  props: {
    attr: {
      type: Object as PropType<CustomMessageTextComponent>,
      required: true,
    },
  },
  setup(props) {
    function clickHandle(e: Event): void {
      if (props.attr.onClick) {
        e.stopPropagation();
        pushUrl(props.attr.onClick, props.attr.reportData);
      }
    }
    let scale = 1;
    if (props?.attr?.scale) {
      scale = toRaw(props.attr.scale);
    }
    const attr = toRaw(props.attr);
    const { content, maxLines } = attr;
    const color = toRaw(attr.style?.color) as string;
    const bgColor = toRaw(attr.style?.backgroundColor) as string;
    const style: CSSProperties = {
      textAlign: attr.textAlign ? attr.textAlign : 'start',
      display: maxLines ? '-webkit-box' : 'block',
      boxOrient: maxLines ? 'vertical' : undefined,
      lineClamp: maxLines ? props.attr.maxLines : undefined,
      textOverflow: maxLines ? 'ellipsis' : '',
      overflow: maxLines ? 'hidden' : '',
      fontSize: attr.style?.fontSize ? `${attr.style.fontSize * scale}px` : '',
      fontWeight: attr.style?.fontWeight ?? 0,
      color: attr.style?.color ? '#'.concat(color.slice(4), color.slice(2, 4)) : '',
      backgroundColor: attr.style?.backgroundColor ? '#'.concat(bgColor.slice(4), bgColor.slice(2, 4)) : '',
    };

    return {
      clickHandle,
      content,
      style,
    };
  },

});


</script>


